import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { useContext, useState, useEffect } from 'react';
import { Title, Label } from '../Banners.styled';
import { getColorFont, getFontFamily } from '../utils';
import Banner, { PROMO_SOLDOUT } from '../../Components/Banner';

const BannerSoldOut = () => {
  const [close, setClose] = useState(false);
  const { globalization } = useContext(CruiseSearchContext);

  const { isMobile } = useContext(CruiseSelectionContext);

  const { filtersDictionary } = globalization?.dictionaries || {};
  const {
    labelTargetedOffersTitleSoldOut,
    labelTargetedOffersDescriptionSoldOut,
  } = filtersDictionary;

  const { utagBannerLoad, constants } = useContext(AnalyticsContext);
  const { TYPES_BANNER } = constants;

  useEffect(() => {
    if (!close) utagBannerLoad(TYPES_BANNER.SOLD_OUT);
  }, [TYPES_BANNER, utagBannerLoad, close]);

  if (close) return null;

  return (
    <Banner
      onClose={() => {
        setClose(true);
      }}
      type={PROMO_SOLDOUT}
      titleBanner={
        <Title $color={getColorFont(isMobile, PROMO_SOLDOUT)} $fontFamily={getFontFamily(isMobile)}>
          {labelTargetedOffersTitleSoldOut}
        </Title>
      }
      contentBanner={
        <Label $weight="400">{labelTargetedOffersDescriptionSoldOut}</Label>
      }
    />
  );
};

export default BannerSoldOut;
